import React from 'react';
import css from './zLand.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import java from "../../../assets/images/extra/java-coffee-cup-logo.png";
import springBoot from "../../../assets/images/extra/springBoot.png";
import git from "../../../assets/images/extra/git.png";
import maven from "../../../assets/images/extra/maven.png";
import zland from "../../../assets/images/projectsImage/zland.jpg";
import react from "../../../assets/images/extra/react-native.png";
import postgres from "../../../assets/images/extra/postgreesql.png";
import github from "../../../assets/images/extra/github--v1.png";
import heroku from "../../../assets/images/extra/heroku.png";

const ZLand: React.FC = () => (
    <div className={css.project} id="zLand">
        <img src={zland} alt=""/>
        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>zLand</h3>
            </div>

            <div className={css.info}>
                <Chip label="Sept. 2021 - Present" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="Sept. 2021 - Present" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>It's a real estate management system.</p>

            <div className={css.learnMoreLink}>
                <p>Demo: <a className={css.link}
                            href='https://zland.herokuapp.com'
                            rel="noopener noreferrer"
                            target="_blank">https://zland.herokuapp.com</a>
                </p>
                <p style={{display: 'flex', flexDirection: "row", alignItems: 'center'}}>
                    (<h5>Note: </h5> wait 30 sec to wake up the instance)
                </p>
            </div>

            <div className={css.learnMoreLink}>
                <p>Source Code: <a className={css.link}
                                   href='https://github.com/adhess?tab=repositories&q=rems'
                                   rel="noopener noreferrer"
                                   target="_blank">https://github.com/adhess?tab=repositories&q=rems</a>
                </p>
            </div>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="Oauth2">
                    <Chip label="Oauth2" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>
            <div className={css.keywords}>
                <Tooltip title="ReactJs">
                    <img src={react} alt=""/>
                </Tooltip>
                <Tooltip title="Java">
                    <img src={java} alt=''/>
                </Tooltip>
                <Tooltip title="Spring Boot">
                    <img src={springBoot} alt=''/>
                </Tooltip>
                <Tooltip title="Maven">
                    <img src={maven} alt=""/>
                </Tooltip>
                <Tooltip title="PostgreeSQL">
                    <img src={postgres} alt=""/>
                </Tooltip>
                <Tooltip title="Github">
                    <img src={github} alt=""/>
                </Tooltip>
                <Tooltip title="Heroku">
                    <img src={heroku} alt=""/>
                </Tooltip>
                <Tooltip title="Git">
                    <img src={git} alt=""/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default ZLand;
